import _ from 'lodash';
import React from 'react';
import { useLogValue } from '~/hooks';
import app from '~/app';

const InfoContext = React.createContext();

export function useInfo() {
  const context = React.useContext( InfoContext );
  if ( ! context ) {
    throw new Error( `useInfo must be used within an InfoProvider` );
  }
  return context;
}

function reducer( state, { id, info } ) {
  return { ...state, [ id ] : info };
}

export function InfoProvider( props ) {
  const [ value, dispatch ] = React.useReducer( reducer, {} );

  React.useEffect( () => {
    const infosvc = app.service( 'info' );
    infosvc.on( 'created', dispatch );
    return () => infosvc.off( 'created', dispatch );
  }, [ dispatch ] );

  useLogValue( 'INFO', value );

  return <InfoContext.Provider value={value} {...props} />;
}
